export const dateSwapper = date => {
  const splittedDate = date.split('-');

  return `${splittedDate[1]}/${splittedDate[2]}/${splittedDate[0]}`;
};
